import MacheteController from '../controller';

export const getViewer = () => MacheteController.instance.viewer;

export default {
  getViewer,
};
